import React, { Component } from 'react';
import Header from '../component/header';
import RiceSection from '../component/riceSection';
import Footer from '../component/footer';

class Rice extends Component {
  constructor(props) {
    super(props)
  }
  
  render() {
    return (
      <div className="rice-frame">
         <Header context={(this.props.context !== undefined) ? this.props.context: "" } />
         <RiceSection context={(this.props.context !== undefined) ? this.props.context: "" } />
         <Footer context={(this.props.context !== undefined) ? this.props.context: "" } />
      </div>
    );
  }
}

export default Rice;



// WEBPACK FOOTER //
// ./src/pages/rice.js